export const buildProjectContext = (qrDetails: any) => {
    // ===========================
    // Areas
    // ===========================

    const areas =
        qrDetails?.portal?.hoblis?.map((item: any) => ({
            label: item.label,
            value: item.name,
            object: item,
        })) || [];

    // ===========================
    // Request Types
    // ===========================

    const requestTypes =
        qrDetails?.request_type?.map((item: any) => ({
            id: item.id,
            name:
                typeof item?.type?.name === "object"
                    ? item.type.name.en || item.type.name.kn
                    : item.type?.name,
            object: item,
        })) || [];

    // ===========================
    // Booths & Villages
    // ===========================

    let hierarchy = qrDetails?.hierarchy || [];

    if (Array.isArray(hierarchy[0])) {
        hierarchy = hierarchy[0];
    }

    const booths: any[] = [];
    const villageMap = new Map();

    hierarchy.forEach((hobli: any) => {
        (hobli.children || []).forEach((booth: any) => {
            const village = booth?.label?.split("-")[0]?.trim() || "";

            if (!villageMap.has(village)) {
                villageMap.set(village, {
                    label: village,
                    value: village,
                });
            }

            booths.push({
                id: booth.id,
                label: booth.label,
                boothNumber: booth.value,
                village,
                object: booth,
            });
        });
    });

    return {
        areas,
        villages: Array.from(villageMap.values()),
        booths,
        requestTypes,
    };
};
